import { render, staticRenderFns } from "./EmployeeSideBar.vue?vue&type=template&id=192cb7e4&"
import script from "./EmployeeSideBar.vue?vue&type=script&lang=js&"
export * from "./EmployeeSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports